module.exports = __webpack_public_path__ + "img/arrow-up.964f40f1.svg";